import Login from './components/index';

export default {
  path: '/login/',
  key: '/login/',
  exact: true,
  component: Login,
};
